import React from 'react';
import './Subscribe.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';

export default function Subscribe({ displayedPaymentSection, displayPaymentSection, isRegistered, slug, contentBtn, susbscribeBtn, handleClickToGoal, hasPlans, hasFormation }) {

    const isMobile = useMediaQuery({ maxWidth: 767 }); // Breakpoint pour MD

    const isExternalLink = (url) => url && (url.startsWith('http://') || url.startsWith('https://'));
    const lienBouton = susbscribeBtn?.LienBouton;
    const inscriptionType = isRegistered
        ? 'internal'
        : (!hasFormation && lienBouton)
            ? (isExternalLink(lienBouton) ? 'external' : 'internal')
            : 'action';
    const inscriptionLink = isRegistered
        ? '/mes-formations/' + slug
        : (!hasFormation && lienBouton)
            ? (isExternalLink(lienBouton) ? lienBouton : '/' + lienBouton)
            : null;

    return (
        <div className='crisis-subscribe'>
            <CustomBtn
                type={'action'}
                title={contentBtn || "je découvre le programme"}
                on_click={handleClickToGoal}
                bkg_color={'#361215'}
                bkg_color_hover={'#EEE6DB'}
                text_color={'#EEE6DB'}
                text_color_hover={'#361215'}
                border_color={'#361215'}
                border_color_hover={'#361215'}
                font_family={'Great Vibes'}
                font_size={'28px'}
                border_radius={'3px'}
                width={'350px'}
                height={'58px'}
                margin={isMobile ? '10px 0' : '20px 0'}
                letter_spacing={2}
            />

            <CustomBtn
                type={inscriptionType}
                title={isRegistered ? "J'accède à ma formation" : susbscribeBtn.TexteBouton}
                link={inscriptionLink}
                on_click={hasFormation && inscriptionType === 'action' ? displayPaymentSection : null}
                bkg_color={!displayedPaymentSection ? 'rgb(238, 230, 219, 0.5)' : '#EEE6DB'}
                bkg_color_hover={'#EEE6DB'}
                text_color={!displayedPaymentSection ? '#361215' : '#361215'}
                text_color_hover={'#361215'}
                border_color={'#361215'}
                border_color_hover={'#361215'}
                font_family={'Great Vibes'}
                font_size={'28px'}
                border_radius={'3px'}
                width={'350px'}
                height={'58px'}
                margin={isMobile ? '10px 0' : '20px 0'}
                letter_spacing={2}
            />


        </div>
    )
}
